// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3YQ1t","file":"styles_file__3QBwu"};